var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audit"},[_c('list',{attrs:{"data":{
            list: _vm.list,
            pagination: _vm.pagination,
            hasLoading: _vm.hasLoading,
            headers: [
                {
                    type: 'component',
                    value: 'contacts',
                    component: function () { return import( /* webpackChunkName: 'BaseContacts' */ '@/components/bundles/contacts/BaseContacts' ); }
                },
                { type: 'default', value: 'taxpayerIdentificationNumber' },
                { type: 'default', value: 'campaign' },
                { type: 'date', value: 'receptionDate', originFormat: 'DD-MM-YYYY HH:mm', finalFormat: 'DD-MM-YYYY HH:mm' },
                { type: 'default', translate: 'state', value: 'latestContactCallState' }
            ],
            destak: 'name',
            auditState: {
                type: 'component',
                value: 'id',
                component: function () { return import( /* webpackChunkName: 'BaseStates' */ '@/components/bundles/states/BaseAuditStates' ); }
            },
        }}}),_c('widget-options',[(_vm.$store.getters.can( 'audit', 'seeTotals' ))?_c('widget-button',{staticClass:"capitalize",attrs:{"settings":{
                action: function () { return _vm.toggleModal({ modalName: 'seeTotals' }); },
                label: 'seeTotals'
            }}}):_vm._e(),(_vm.$store.getters.can( 'audit', 'addContact' ))?_c('widget-anchor',{attrs:{"settings":{
                url: "/audit/add",
                label: 'addContact'
            }}}):_vm._e()],1),_c('modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.modals.seeTotals.show),expression:"modals.seeTotals.show"}],key:_vm.modals.seeTotals.show,attrs:{"form":{
            class: 'modal--see-totals'
        },"customSettings":{
            color: 'green',
            class: 'modal--see-totals__content',
            show: {
                infoSection: false,
                actions: false
            }
        }},on:{"close":function($event){return _vm.toggleModal({ modalName: 'seeTotals', show: false })}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"modal--see-totals__header"},[_vm._v(_vm._s(_vm.$t('global.seeTotals')))])]},proxy:true},{key:"modal__body",fn:function(){return [_c('base-field',{staticClass:"script__campaigns",attrs:{"settings":{
                    label: { class: 'capitalize', text: _vm.$t('global.campaign') },
                    input: {
                        component: 'InputAutocomplete',
                        name: 'campaign',
                        id: 'campaign',
                        type: 'text',
                        value: '',
                        targetClass: 'scrip__campaigns__input field__input--default typography--default color--default',
                        browserAutocomplete: 'off',
                        isMissing: _vm.errors.missing.campaign,
                        dynamicData: {
                            data: _vm.campaigns.drop,
                            ordering: _vm.campaigns.loading
                        },
                        noListener: true
                    },
                    allowFilling: true
                }}}),(_vm.payload.campaign)?_c('div',{staticClass:"modal--see-totals__charts display--flex"},[_c('base-card',{staticClass:"modal--see-totals__charts__totals-by-typification",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('reporting.totalsByTypification'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"campaign__body"},[_c('base-chart',{attrs:{"loading":_vm.modals.seeTotals.charts.totalsByTypification.loading,"chart":_vm.modals.seeTotals.charts.totalsByTypification.data}})],1)]},proxy:true}],null,false,515836020)}),_c('base-card',{staticClass:"modal--see-totals__charts__final-typifications-by-hour",scopedSlots:_vm._u([{key:"card__title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('reporting.finalTypificationsByHour'))+" ")]},proxy:true},{key:"card__body",fn:function(){return [_c('div',{staticClass:"campaign__body"},[_c('base-chart',{attrs:{"loading":_vm.modals.seeTotals.charts.finalTypificationsByHour.loading,"chart":_vm.modals.seeTotals.charts.finalTypificationsByHour.data}})],1)]},proxy:true}],null,false,1931445082)})],1):_vm._e()]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }